import { useCallback, useEffect, useReducer } from "react";
import {
  getImeiCheckAttemptStorageKey,
  recordImeiCheckAttempt,
  remainingCooldownSeconds,
  resolveImeiCheckAttemptState,
} from "../utils/imei-check-attempt-storage";

type UseImeiCheckRateLimitResult = {
  inCooldown: boolean;
  isBlocked: boolean;
  remainingSeconds: number;
  registerAttempt: () => void;
};

export function useImeiCheckRateLimit(): UseImeiCheckRateLimitResult {
  const [, bump] = useReducer((n: number) => n + 1, 0);
  const storageKey = getImeiCheckAttemptStorageKey();
  const snapshot = resolveImeiCheckAttemptState();
  const inCooldown =
    snapshot.cooldownUntil != null && Date.now() < snapshot.cooldownUntil;
  const remainingSeconds = remainingCooldownSeconds(snapshot.cooldownUntil);

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === storageKey) bump();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [storageKey]);

  useEffect(() => {
    if (!inCooldown) return;
    const id = window.setInterval(() => bump(), 1000);
    return () => window.clearInterval(id);
  }, [inCooldown]);

  const registerAttempt = useCallback(() => {
    recordImeiCheckAttempt();
    bump();
  }, []);

  return {
    inCooldown,
    isBlocked: inCooldown,
    remainingSeconds,
    registerAttempt,
  };
}
